/**
 * Вкладка «Настройки сервисов»
 */

import React, { FC } from 'react';
import { Space } from 'antd';

import FallSection from './FallSection';
import AccStillSection from './AccStillSection';

const Services: FC = () => {
  return (
    <div style={{ padding: '24px 0' }}>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <FallSection />
        <AccStillSection />
      </Space>
    </div>
  );
};

export default Services;
